import { Amplify } from 'aws-amplify';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { RecoilRoot } from 'recoil';
import App from './App';
import { awsLibraryConf, awsConf } from './aws-exports';
import './index.css';

Amplify.configure(awsConf, awsLibraryConf);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <RecoilRoot>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </RecoilRoot>
);
